import { apiProxyRequest } from "Api/apiProxyRequest";

import type { BaseIntegration, GetIntegrationParams } from "./types";

export const getIntegrationRequest = ({
  projectId,
  integrationId
}: GetIntegrationParams) =>
  apiProxyRequest<BaseIntegration>(
    `/projects/${projectId}/integrations/${integrationId}`
  );
